import React, { Component } from 'react';
import Nav from "../../../containers/Navbar/Navbar"
import { connect } from 'react-redux';
import * as projectActions from "../../actions/projectsActions"
import ReactTable from 'react-table'
// import 'react-table/react-table.css'
import NavbarTop from "../../../containers/Navbar/NavbarTop";


class TodayProjects extends Component {
    constructor(props) {
        super(props);
        this.state = {
            value: "",
            imageURL: "",
            navSide: true,
            modalView: false
        }
    }

    componentDidMount() {
        this.props.getTodayProjects();
    }

    render() {
        const columns = [
            {
                Header: 'Project Name', accessor: 'projectName',
                Cell: props => {
                    return (<span style={{ color: "black", fontWeight: "800", paddingLeft: 10 }}>{props.original.projectName}</span>)
                }
            },
            { Header: 'Message', accessor: 'message' },
            {
                Header: 'Status', accessor: 'status',
                Cell: props => {
                    var date = new Date(props.original.startTime);
                    return (<span>{(props.original.status == "1" ? <span style={{ color: "white", backgroundColor: "green", borderRadius: 10, padding: 2, paddingLeft: 10, paddingRight: 10 }}>Active</span> : <span style={{ color: "white", backgroundColor: "red", borderRadius: 10, padding: 2, paddingLeft: 10, paddingRight: 10 }}>Inactive</span>)}</span>)
                }
            },
            {
                Header: 'Current Hours', accessor: 'currentHours',
                Cell: props => {
                    return (<span>{props.original.currentHours + "H"}</span>)
                }
            },
            {
                Header: 'Expected Hours', accessor: 'expectedHours',
                Cell: props => {
                    return (<span>{props.original.expectedHours + "H"}</span>)
                }
            },
            {
                Header: 'Start Time', accessor: 'startTime',
                Cell: props => {
                    var date = new Date(props.original.startTime);
                    return (<span>{date.getFullYear() + "/ " + (date.getMonth() + 1) + "/ " + date.getDate()}</span>)
                }
            },
            {
                Header: 'End Date', accessor: 'endDate',
                Cell: props => {
                    var date = new Date(props.original.endDate);
                    return (<span>{date.getFullYear() + "/ " + (date.getMonth() + 1) + "/ " + date.getDate()}</span>)
                }
            },
            {
                Header: 'Color', accessor: 'color',
                Cell: props => {
                    return (<div style={{ height: "100%", width: "100%", backgroundColor: "#" + props.original.color }}></div>)
                }
            },
            {
                Header: 'Image', accessor: 'image',
                Cell: props => {
                    return (<button onClick={() => {
                        this.setState({ modalView: true, imageURL: props.original.image })
                    }} style={{ height: "100%", width: "100%", backgroundColor: "black", color: "white", textAlign: "center", padding: 2, fontSize: 13, borderColor: "gray" }}>View Image</button>)
                }
            },
            {
                Header: '', accessor: '',
                Cell: props => {
                    return (<button onClick={() => {
                        this.setState({ modalView: true, imageURL: props.original.image })
                    }} style={{ height: "100%", width: "100%", backgroundColor: "black", color: "white", textAlign: "center", padding: 2, fontSize: 13, borderColor: "gray" }}>Edit</button>)
                }
            }
        ]
        return (
            <>
                {this.state.modalView &&
                    <div id="myModal" class="modal">
                        <span class="close" onClick={() => { this.setState({ modalView: false }) }}>X</span>
                        <img src={this.state.imageURL} class="modal-content" id="img01" />
                        <div id="caption"></div>
                    </div>}
                <div style={{ padding: 10, paddingLeft: 280 }}>
                    <ReactTable
                        data={(this.props.projects == null ? [] : this.props.projects.todayProjects)}
                        columns={columns}
                        defaultPageSize={10}
                        sortable='true'
                    />
                </div>


            </>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        projects: state.projectReducer
    }
}

export default connect(mapStateToProps, projectActions)(TodayProjects);